import {last, sortBy} from 'lodash';
import {createSelector} from 'reselect';

import {STATUS_REDUCER_STATE_ID} from './status_constants';
import {RootState} from 'src/js/store';

const latestError = (state: RootState) => {
  let result;
  if (state[STATUS_REDUCER_STATE_ID]?.errors?.length > 0) {
    result = last(sortBy(state[STATUS_REDUCER_STATE_ID].errors, ['timestamp']));
  }
  return result;
};

export const getLatestError = createSelector(
  [latestError],
  (latestErrorItem) => latestErrorItem
);
